import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import localforage from 'localforage';
import Cookies from 'js-cookie';
import cookie from 'cookie';
import md5 from 'md5';
import { v4 as uuid } from 'uuid';
import Vue from 'vue';
import * as API from '~/api';
import Themes from '@/components/layout/themes';
var Account = /*#__PURE__*/function () {
  function Account() {
    _classCallCheck(this, Account);
    this.guid = uuid();
    this.info = null;
    this.locked = false;
    this.attempts = 0;
    this.history = '/';
    this.panel = 'modal';
    this.home = '/';
    this.sort = {};
    this.scheduleView = '/schedule/day';
    this.created_at = new Date();
    this.updated_at = new Date();
  }
  return _createClass(Account, [{
    key: "setInfo",
    value: function setInfo(data) {
      this.info = data;
      this.updated_at = new Date();
    }
  }]);
}();
export default (function (context, inject) {
  var plugin = {
    /**
     * Initialize the plugin and clear any old accounts that are no longer valid
     */
    init: function init() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var token, layout, shouldClear;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              Cookies.set('auth.client_id', _this.clientId);
              Cookies.set('auth.scope', _this.scopes.join(' '));
              API.Model.serverRequest = context.req;
              token = process.server && context.req.headers.cookie ? cookie.parse(context.req.headers.cookie)['auth.app_token'] : Cookies.get('auth.app_token');
              layout = process.server && context.req.headers.cookie ? cookie.parse(context.req.headers.cookie)['ovatu.layout'] : Cookies.get('ovatu.layout');
              if (!token) {
                _context.next = 13;
                break;
              }
              _context.t0 = process.client;
              if (!_context.t0) {
                _context.next = 11;
                break;
              }
              _context.next = 10;
              return _this.detectPwaCookieMismatch();
            case 10:
              _context.t0 = _context.sent;
            case 11:
              shouldClear = _context.t0;
              if (shouldClear) {
                Cookies.remove('auth.app_token');
                context.store.commit('auth/setActive', null);
              } else {
                _this.tokenLogin({
                  token: token,
                  sync: false
                });
              }
            case 13:
              if (layout === 'app') {
                // Force system color mode preference for app webview
                if (context.$colorMode) {
                  context.$colorMode.preference = 'system';
                }
                _this.initFromCredentials();
              }
              _this.clear();
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    /**
     * Detect iOS PWA cookie/storage mismatch.
     * Returns true when running in standalone mode with auth cookies
     * but no localforage data (i.e. cookies were copied on install
     * but IndexedDB was not).
     */
    detectPwaCookieMismatch: function detectPwaCookieMismatch() {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var isStandalone, authCookie, activeGuid, _parsed$auth, parsed, hasData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isStandalone = window.navigator.standalone === true || window.matchMedia && window.matchMedia('(display-mode: standalone)').matches;
              if (isStandalone) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return", false);
            case 3:
              // Find the active account guid from the persisted vuex state cookie
              authCookie = Cookies.get('auth');
              if (authCookie) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return", false);
            case 6:
              _context2.prev = 6;
              parsed = JSON.parse(decodeURIComponent(authCookie));
              activeGuid = parsed === null || parsed === void 0 ? void 0 : (_parsed$auth = parsed.auth) === null || _parsed$auth === void 0 ? void 0 : _parsed$auth.active;
              _context2.next = 14;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](6);
              return _context2.abrupt("return", false);
            case 14:
              if (activeGuid) {
                _context2.next = 16;
                break;
              }
              return _context2.abrupt("return", false);
            case 16:
              _context2.prev = 16;
              _context2.next = 19;
              return localforage.getItem("".concat(activeGuid, ".customers.items"));
            case 19:
              hasData = _context2.sent;
              return _context2.abrupt("return", !hasData);
            case 23:
              _context2.prev = 23;
              _context2.t1 = _context2["catch"](16);
              return _context2.abrupt("return", false);
            case 26:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[6, 11], [16, 23]]);
      }))();
    },
    /**
     * Initialize session from credentials cookie when accounts store is empty
     * This supports external apps (e.g. Flutter webview) that set credentials directly
     */
    initFromCredentials: function initFromCredentials() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _context$req, _context$req$headers, _auth, _auth$auth, _credentials;
        var cookies, authCookie, auth, activeGuid, existingAccount, credentialsCookie, credentials, account, theme, info;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              console.log('initFromCredentials');
              cookies = process.server && (_context$req = context.req) !== null && _context$req !== void 0 && (_context$req$headers = _context$req.headers) !== null && _context$req$headers !== void 0 && _context$req$headers.cookie ? cookie.parse(context.req.headers.cookie) : Cookies.get(); // Parse the auth cookie to get active guid
              authCookie = cookies === null || cookies === void 0 ? void 0 : cookies.auth;
              if (authCookie) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return");
            case 5:
              _context3.prev = 5;
              auth = JSON.parse(decodeURIComponent(authCookie));
              _context3.next = 12;
              break;
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](5);
              return _context3.abrupt("return");
            case 12:
              activeGuid = (_auth = auth) === null || _auth === void 0 ? void 0 : (_auth$auth = _auth.auth) === null || _auth$auth === void 0 ? void 0 : _auth$auth.active;
              if (activeGuid) {
                _context3.next = 15;
                break;
              }
              return _context3.abrupt("return");
            case 15:
              // Check if we already have this account in the store with info
              existingAccount = context.store.state.auth.accounts[activeGuid];
              if (!(existingAccount !== null && existingAccount !== void 0 && existingAccount.info)) {
                _context3.next = 18;
                break;
              }
              return _context3.abrupt("return");
            case 18:
              // Check if credentials exist for this guid
              credentialsCookie = cookies["auth.credentials.".concat(activeGuid)];
              if (credentialsCookie) {
                _context3.next = 21;
                break;
              }
              return _context3.abrupt("return");
            case 21:
              _context3.prev = 21;
              credentials = JSON.parse(decodeURIComponent(credentialsCookie));
              _context3.next = 28;
              break;
            case 25:
              _context3.prev = 25;
              _context3.t1 = _context3["catch"](21);
              return _context3.abrupt("return");
            case 28:
              if ((_credentials = credentials) !== null && _credentials !== void 0 && _credentials.access_token) {
                _context3.next = 30;
                break;
              }
              return _context3.abrupt("return");
            case 30:
              _this2.setReady(false);

              // Create a new account with the guid from the cookie
              account = new Account();
              account.guid = activeGuid;

              // Add account to store first so API calls are authenticated
              context.store.commit('auth/addAccount', account);

              // Set theme from cookie
              theme = process.server && context.req.headers.cookie ? cookie.parse(context.req.headers.cookie)['ovatu.theme'] : Cookies.get('ovatu.theme');
              if (theme) {
                _this2.setTheme(theme);
              }
              _context3.prev = 36;
              console.log('fetching info');
              // Fetch account info using the existing credentials
              _context3.next = 40;
              return API.Auth.info();
            case 40:
              info = _context3.sent;
              console.log('setting info');
              account.setInfo(info);
              console.log('committing info');
              // Update account info in store
              context.store.commit('auth/setAccountInfo', {
                guid: activeGuid,
                info: info
              });
              console.log('setting ready');
              // Set theme
              _this2.setReady(true);
              _context3.next = 53;
              break;
            case 49:
              _context3.prev = 49;
              _context3.t2 = _context3["catch"](36);
              context.store.commit('auth/removeAccount', account);
              _this2.setReady(true);
            case 53:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[5, 9], [21, 25], [36, 49]]);
      }))();
    },
    /**
     * Login a new user, add the account and sync data
     * @param {function} callback
     */
    login: function login(callback) {
      var _arguments = arguments,
        _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _ref, _ref$sync, sync, account, response, info, accounts, id, existing, _info$location, _info$location$locati;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _ref = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref$sync = _ref.sync, sync = _ref$sync === void 0 ? true : _ref$sync;
              _this3.setReady(false);

              // New empty account
              account = new Account(); // Set active account cookie for initial login
              context.store.commit('auth/setActive', account.guid);
              _context4.prev = 4;
              _context4.next = 7;
              return callback();
            case 7:
              response = _context4.sent;
              _context4.next = 10;
              return API.Auth.info();
            case 10:
              info = _context4.sent;
              account.setInfo(info);
              accounts = context.store.state.auth.accounts;
              id = account.info.employee.idEmployee;
              existing = Object.values(accounts).find(function (a) {
                return a.info.employee.idEmployee === id;
              });
              if (existing) {
                // Remove existing account
                context.store.commit('auth/removeAccount', existing);
              }

              // Add account to store
              _this3.addAccount(account);

              // Set the account to active
              _this3.setActive(account);
              if (sync) {
                _this3.syncActive();
                _this3.redirect();
              } else {
                _this3.setTheme((info === null || info === void 0 ? void 0 : (_info$location = info.location) === null || _info$location === void 0 ? void 0 : (_info$location$locati = _info$location.locationTheme) === null || _info$location$locati === void 0 ? void 0 : _info$location$locati.code) || 'ovatu');
                _this3.setReady(true);
              }
              // this.syncActive()
              // this.setReady(true)

              // context.redirect('/')
              _context4.next = 27;
              break;
            case 21:
              _context4.prev = 21;
              _context4.t0 = _context4["catch"](4);
              _this3.setActive(null);
              _this3.setReady(true);
              console.log(_context4.t0);
              throw _context4.t0;
            case 27:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[4, 21]]);
      }))();
    },
    passwordLogin: function passwordLogin(_ref2) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var idLocation, email, password;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              idLocation = _ref2.idLocation, email = _ref2.email, password = _ref2.password;
              _context5.next = 3;
              return _this4.login(function () {
                return API.Auth.login({
                  oauth_client: _this4.clientId,
                  location: idLocation,
                  email: email,
                  password: password
                });
              });
            case 3:
              return _context5.abrupt("return", _context5.sent);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    codeLogin: function codeLogin(_ref3) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var idLocation, email, token, code;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              idLocation = _ref3.idLocation, email = _ref3.email, token = _ref3.token, code = _ref3.code;
              _context6.next = 3;
              return _this5.login(function () {
                return API.Auth.codeLogin({
                  oauth_client: _this5.clientId,
                  location: idLocation,
                  email: email,
                  token: token,
                  code: code
                });
              });
            case 3:
              return _context6.abrupt("return", _context6.sent);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    tokenLogin: function tokenLogin(_ref4) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var token, _ref4$sync, sync;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              token = _ref4.token, _ref4$sync = _ref4.sync, sync = _ref4$sync === void 0 ? true : _ref4$sync;
              _context7.next = 3;
              return _this6.login(function () {
                return API.Auth.tokenLogin({
                  oauth_client: _this6.clientId,
                  token: token
                });
              }, {
                sync: sync
              });
            case 3:
              return _context7.abrupt("return", _context7.sent);
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    requestCode: function requestCode(_ref5) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var idLocation, email;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              idLocation = _ref5.idLocation, email = _ref5.email;
              _context8.next = 3;
              return API.Auth.requestCode({
                oauth_client: _this7.clientId,
                location: idLocation,
                email: email
              });
            case 3:
              return _context8.abrupt("return", _context8.sent);
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    /* async forgotDomain ({ idLocation, email, token, code }) {
      return await API.Auth.forgotDomain({ oauth_client: this.clientId, location: idLocation, email, token, code })
    }, */
    find: function find(_ref6) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var email, token, code;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              email = _ref6.email, token = _ref6.token, code = _ref6.code;
              _context9.next = 3;
              return API.Auth.accounts({
                oauth_client: _this8.clientId,
                email: email,
                token: token,
                code: code
              });
            case 3:
              return _context9.abrupt("return", _context9.sent);
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    resetPassword: function resetPassword(_ref7) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        var idLocation, email, password, confirm, token, code;
        return regeneratorRuntime.wrap(function _callee0$(_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              idLocation = _ref7.idLocation, email = _ref7.email, password = _ref7.password, confirm = _ref7.confirm, token = _ref7.token, code = _ref7.code;
              _context0.next = 3;
              return API.Auth.resetPassword({
                oauth_client: _this9.clientId,
                location: idLocation,
                email: email,
                password: password,
                confirm: confirm,
                token: token,
                code: code
              });
            case 3:
              return _context0.abrupt("return", _context0.sent);
            case 4:
            case "end":
              return _context0.stop();
          }
        }, _callee0);
      }))();
    },
    checkPin: function checkPin(_ref8) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
        var pin;
        return regeneratorRuntime.wrap(function _callee1$(_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              pin = _ref8.pin;
              _context1.next = 3;
              return API.Auth.checkPin({
                pin: pin
              });
            case 3:
              return _context1.abrupt("return", _context1.sent);
            case 4:
            case "end":
              return _context1.stop();
          }
        }, _callee1);
      }))();
    },
    logout: function logout() {
      var _arguments2 = arguments,
        _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var _ref9, _ref9$revokeTokens, revokeTokens, account, success;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _ref9 = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {}, _ref9$revokeTokens = _ref9.revokeTokens, revokeTokens = _ref9$revokeTokens === void 0 ? true : _ref9$revokeTokens;
              account = _this0.active;
              if (!revokeTokens) {
                _context10.next = 12;
                break;
              }
              _context10.prev = 3;
              _context10.next = 6;
              return API.Auth.logout();
            case 6:
              success = _context10.sent;
              _context10.next = 12;
              break;
            case 9:
              _context10.prev = 9;
              _context10.t0 = _context10["catch"](3);
              _this0.$sentry.captureException(_context10.t0);
            case 12:
              _this0.setActive(null);
              if (account) {
                context.store.commit('auth/removeAccount', account);
                context.redirect('/auth/login/email');
              }
            case 14:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[3, 9]]);
      }))();
    },
    lock: function lock() {
      context.store.commit('auth/setLock', {
        locked: true
      });
    },
    unlock: function unlock() {
      var _arguments3 = arguments,
        _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var _ref0, pin, _ref0$override, override, _ref0$sync, sync, employee, pinHash, idEmployee, correct;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _ref0 = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : {}, pin = _ref0.pin, _ref0$override = _ref0.override, override = _ref0$override === void 0 ? false : _ref0$override, _ref0$sync = _ref0.sync, sync = _ref0$sync === void 0 ? false : _ref0$sync;
              employee = _this1.active.info.employee;
              pinHash = employee.pinHash;
              idEmployee = employee.idEmployee;
              correct = override || pinHash === md5(pin + idEmployee + 'e475a4a8df94');
              if (correct) {
                _context11.next = 15;
                break;
              }
              _context11.prev = 6;
              _context11.next = 9;
              return _this1.checkPin({
                pin: pin
              });
            case 9:
              correct = _context11.sent;
              _context11.next = 15;
              break;
            case 12:
              _context11.prev = 12;
              _context11.t0 = _context11["catch"](6);
              correct = false;
            case 15:
              if (!correct) {
                _context11.next = 22;
                break;
              }
              context.store.commit('auth/setLock', {
                locked: false
              });
              if (sync) {
                _this1.syncActive();
              }
              _this1.setAttempts(0);
              _this1.redirect();
              _context11.next = 23;
              break;
            case 22:
              throw new Error('Invalid pin');
            case 23:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[6, 12]]);
      }))();
    },
    switch: function _switch() {
      context.app.router.push('/auth/switch');
    },
    redirect: function redirect() {
      var redirect = context.store.state.auth.auth.redirect;
      if (redirect) {
        context.redirect(redirect);
        context.store.commit('auth/set', {
          key: 'redirect',
          value: null
        });
      } else {
        var _this$active;
        context.redirect(((_this$active = this.active) === null || _this$active === void 0 ? void 0 : _this$active.history) || '/');
      }
    },
    addAccount: function addAccount(account) {
      var accounts = context.store.state.auth.accounts;
      var accountIDs = Object.values(accounts).map(function (account) {
        return account.info.employee.idEmployee;
      });
      var ID = account.info.employee.idEmployee;
      if (accountIDs.includes(ID)) {
        // const error = { errors: { id: ['Account already logged in'] } }
        // throw error
      }
      context.store.commit('auth/addAccount', account);
      return true;
    },
    fetchInfo: function fetchInfo() {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var _context$$sentry, _info$location2, _info$location3, _info$employee, _info$employee2, _info$location4, info;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return API.Auth.info();
            case 3:
              info = _context12.sent;
              (_context$$sentry = context.$sentry) === null || _context$$sentry === void 0 ? void 0 : _context$$sentry.setTags({
                location_name: info === null || info === void 0 ? void 0 : (_info$location2 = info.location) === null || _info$location2 === void 0 ? void 0 : _info$location2.title,
                location_id: info === null || info === void 0 ? void 0 : (_info$location3 = info.location) === null || _info$location3 === void 0 ? void 0 : _info$location3.idLocation,
                employee_name: info === null || info === void 0 ? void 0 : (_info$employee = info.employee) === null || _info$employee === void 0 ? void 0 : _info$employee.displayName,
                employee_id: info === null || info === void 0 ? void 0 : (_info$employee2 = info.employee) === null || _info$employee2 === void 0 ? void 0 : _info$employee2.idEmployee,
                admin_link: "admin.ovatu.dev/location/".concat(info === null || info === void 0 ? void 0 : (_info$location4 = info.location) === null || _info$location4 === void 0 ? void 0 : _info$location4.idLocation)
              });
              return _context12.abrupt("return", info);
            case 8:
              _context12.prev = 8;
              _context12.t0 = _context12["catch"](0);
              console.log(_context12.t0);
            case 11:
            case "end":
              return _context12.stop();
          }
        }, _callee12, null, [[0, 8]]);
      }))();
    },
    fetchInfoOnce: function fetchInfoOnce() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (_this10.info) {
                _context13.next = 4;
                break;
              }
              _context13.next = 3;
              return _this10.fetchInfo();
            case 3:
              return _context13.abrupt("return", _context13.sent);
            case 4:
              return _context13.abrupt("return", _this10.info);
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    setActive: function setActive(account) {
      var _arguments4 = arguments,
        _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var _ref1, _ref1$sync, sync, info;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _ref1 = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : {}, _ref1$sync = _ref1.sync, sync = _ref1$sync === void 0 ? false : _ref1$sync;
              context.store.commit('auth/setActive', (account === null || account === void 0 ? void 0 : account.guid) || null);
              if (!account) {
                _context14.next = 8;
                break;
              }
              _this11.resetHydration();
              _context14.next = 6;
              return _this11.fetchInfo();
            case 6:
              info = _context14.sent;
              if (info) {
                context.store.commit('auth/setAccountInfo', {
                  info: info
                });

                // Sync local storage and set helpscout for active account
                if (sync) {
                  _this11.syncActive();
                }
              }
            case 8:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    /**
     * Validate and sync the active account info
     */
    syncInfo: function syncInfo() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var active, _info$plan, info, inactive, _info$location5, _info$location5$locat;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              active = _this12.active;
              if (!active) {
                _context15.next = 16;
                break;
              }
              _context15.next = 4;
              return _this12.fetchInfo();
            case 4:
              info = _context15.sent;
              inactive = info === null || info === void 0 ? void 0 : (_info$plan = info.plan) === null || _info$plan === void 0 ? void 0 : _info$plan.isPlanSubscriptionStateInactive;
              if (!(inactive && !(info !== null && info !== void 0 && info.adminUser))) {
                _context15.next = 13;
                break;
              }
              context.redirect('/account/inactive');
              _this12.helpscout();
              _this12.setTheme((info === null || info === void 0 ? void 0 : (_info$location5 = info.location) === null || _info$location5 === void 0 ? void 0 : (_info$location5$locat = _info$location5.locationTheme) === null || _info$location5$locat === void 0 ? void 0 : _info$location5$locat.code) || 'ovatu');
              _this12.setReady(true);
              _context15.next = 16;
              break;
            case 13:
              if (!info) {
                _context15.next = 16;
                break;
              }
              _context15.next = 16;
              return context.store.commit('auth/setAccountInfo', {
                info: info
              });
            case 16:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    /**
     * Validate and sync the active account info & models
     */
    syncActive: function syncActive() {
      var _arguments5 = arguments,
        _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var _active$info, _active$info$location, _active$info2, _active$info2$employe;
        var _ref10, _ref10$lock, lock, active, layout, _info$plan2, info, inactive, _info$location6, _info$location6$locat;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _ref10 = _arguments5.length > 0 && _arguments5[0] !== undefined ? _arguments5[0] : {}, _ref10$lock = _ref10.lock, lock = _ref10$lock === void 0 ? false : _ref10$lock;
              active = _this13.active;
              if (!(lock && active !== null && active !== void 0 && (_active$info = active.info) !== null && _active$info !== void 0 && (_active$info$location = _active$info.location) !== null && _active$info$location !== void 0 && _active$info$location.webPINRequired && !!(active !== null && active !== void 0 && (_active$info2 = active.info) !== null && _active$info2 !== void 0 && (_active$info2$employe = _active$info2.employee) !== null && _active$info2$employe !== void 0 && _active$info2$employe.pinHash))) {
                _context16.next = 5;
                break;
              }
              context.store.commit('auth/setLock', {
                locked: true
              });
              return _context16.abrupt("return");
            case 5:
              layout = process.server && context.req.headers.cookie ? cookie.parse(context.req.headers.cookie)['ovatu.layout'] : Cookies.get('ovatu.layout');
              if (!active) {
                _context16.next = 53;
                break;
              }
              _context16.next = 9;
              return _this13.fetchInfo();
            case 9:
              info = _context16.sent;
              inactive = info === null || info === void 0 ? void 0 : (_info$plan2 = info.plan) === null || _info$plan2 === void 0 ? void 0 : _info$plan2.isPlanSubscriptionStateInactive;
              if (!(inactive && !(info !== null && info !== void 0 && info.adminUser))) {
                _context16.next = 17;
                break;
              }
              context.redirect('/account/inactive');
              _this13.helpscout();
              _this13.setReady(true);
              _context16.next = 53;
              break;
            case 17:
              if (!info) {
                _context16.next = 53;
                break;
              }
              _context16.next = 20;
              return context.store.commit('auth/setAccountInfo', {
                info: info
              });
            case 20:
              context.$centrifuge.connect();
              if (!(layout !== 'app')) {
                _context16.next = 51;
                break;
              }
              _context16.next = 24;
              return context.store.dispatch('customer/sync', {
                change: true
              });
            case 24:
              _context16.next = 26;
              return context.store.dispatch('service/sync', {
                change: true
              });
            case 26:
              _context16.next = 28;
              return context.store.dispatch('employee/sync', {
                change: true
              });
            case 28:
              _context16.next = 30;
              return context.store.dispatch('segment/sync', {
                change: true
              });
            case 30:
              _context16.next = 32;
              return context.store.dispatch('product/sync', {
                change: true
              });
            case 32:
              _context16.next = 34;
              return context.store.dispatch('integration/sync', {
                change: true
              });
            case 34:
              _context16.next = 36;
              return context.store.dispatch('form/sync', {
                change: true
              });
            case 36:
              _context16.next = 38;
              return context.store.dispatch('voucher/sync', {
                change: true
              });
            case 38:
              _context16.next = 40;
              return context.store.dispatch('customFields/sync', {
                change: true
              });
            case 40:
              _context16.next = 42;
              return context.store.dispatch('discountModel/sync', {
                change: true
              });
            case 42:
              _context16.next = 44;
              return context.store.dispatch('chargeModel/sync', {
                change: true
              });
            case 44:
              _context16.next = 46;
              return context.store.dispatch('paymentModel/sync', {
                change: true
              });
            case 46:
              _context16.next = 48;
              return context.store.dispatch('tax/sync', {
                change: true
              });
            case 48:
              _context16.next = 50;
              return context.store.dispatch('pass/sync', {
                change: true
              });
            case 50:
              _this13.helpscout();
            case 51:
              _this13.setTheme((info === null || info === void 0 ? void 0 : (_info$location6 = info.location) === null || _info$location6 === void 0 ? void 0 : (_info$location6$locat = _info$location6.locationTheme) === null || _info$location6$locat === void 0 ? void 0 : _info$location6$locat.code) || 'ovatu');
              _this13.setReady(true);
            case 53:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    resetHydration: function resetHydration() {
      context.store.commit('customer/setHydrated', false);
      context.store.commit('service/setHydrated', false);
      context.store.commit('employee/setHydrated', false);
      context.store.commit('segment/setHydrated', false);
      context.store.commit('product/setHydrated', false);
      context.store.commit('integration/setHydrated', false);
      context.store.commit('form/setHydrated', false);
      context.store.commit('voucher/setHydrated', false);
      context.store.commit('customFields/setHydrated', false);
      context.store.commit('discountModel/setHydrated', false);
      context.store.commit('chargeModel/setHydrated', false);
      context.store.commit('paymentModel/setHydrated', false);
      context.store.commit('tax/setHydrated', false);
      context.store.commit('pass/setHydrated', false);
    },
    helpscout: function helpscout() {
      if (context.$config.instance !== 'demo') {
        var _this$active2, _this$active2$info, _this$active3, _this$active3$info;
        var employee = (_this$active2 = this.active) === null || _this$active2 === void 0 ? void 0 : (_this$active2$info = _this$active2.info) === null || _this$active2$info === void 0 ? void 0 : _this$active2$info.employee;
        var location = (_this$active3 = this.active) === null || _this$active3 === void 0 ? void 0 : (_this$active3$info = _this$active3.info) === null || _this$active3$info === void 0 ? void 0 : _this$active3$info.location;
        if (window && employee && location) {
          var _employee$role;
          var data = {
            idClient: location.idClient,
            idLocation: location.idLocation,
            slug: location.slug,
            name: employee.displayName,
            email: employee.email,
            role: (_employee$role = employee.role) === null || _employee$role === void 0 ? void 0 : _employee$role.name,
            signature: employee.helpscoutSignature
          };
          try {
            var _window$Beacon, _window;
            (_window$Beacon = (_window = window).Beacon) === null || _window$Beacon === void 0 ? void 0 : _window$Beacon.call(_window, 'identify', data);
          } catch (e) {
            console.log(e);
          }
        }
      }
    },
    clear: function clear() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var keys, guids, _iterator, _step, _loop;
        return regeneratorRuntime.wrap(function _callee17$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              _context18.next = 3;
              return localforage.keys();
            case 3:
              keys = _context18.sent;
              guids = _this14.accountIDs;
              _iterator = _createForOfIteratorHelper(keys);
              _context18.prev = 6;
              _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
                var key, guid;
                return regeneratorRuntime.wrap(function _loop$(_context17) {
                  while (1) switch (_context17.prev = _context17.next) {
                    case 0:
                      key = _step.value;
                      guid = key.split('.')[0];
                      if (!guids.includes(guid)) {
                        localforage.removeItem(key, function () {
                          return console.log('removed: ' + key);
                        });
                      }
                    case 3:
                    case "end":
                      return _context17.stop();
                  }
                }, _loop);
              });
              _iterator.s();
            case 9:
              if ((_step = _iterator.n()).done) {
                _context18.next = 13;
                break;
              }
              return _context18.delegateYield(_loop(), "t0", 11);
            case 11:
              _context18.next = 9;
              break;
            case 13:
              _context18.next = 18;
              break;
            case 15:
              _context18.prev = 15;
              _context18.t1 = _context18["catch"](6);
              _iterator.e(_context18.t1);
            case 18:
              _context18.prev = 18;
              _iterator.f();
              return _context18.finish(18);
            case 21:
              _context18.next = 26;
              break;
            case 23:
              _context18.prev = 23;
              _context18.t2 = _context18["catch"](0);
              console.log(_context18.t2);
            case 26:
            case "end":
              return _context18.stop();
          }
        }, _callee17, null, [[0, 23], [6, 15, 18, 21]]);
      }))();
    },
    setMaintenance: function setMaintenance(_ref11) {
      var title = _ref11.title,
        content = _ref11.content;
      context.store.commit('setMaintenance', {
        title: title,
        content: content
      });
    },
    setHome: function setHome(home) {
      context.store.commit('auth/setHome', {
        home: home
      });
    },
    setSort: function setSort(_ref12) {
      var model = _ref12.model,
        value = _ref12.value;
      context.store.commit('auth/setSort', {
        model: model,
        value: value
      });
    },
    setLock: function setLock(locked) {
      context.store.commit('auth/setLock', {
        locked: locked
      });
    },
    setHistory: function setHistory(path) {
      context.store.commit('auth/setHistory', {
        path: path
      });
    },
    setAttempts: function setAttempts(value) {
      context.store.commit('auth/setAttempts', {
        value: value
      });
    },
    setReady: function setReady(value) {
      context.store.commit('auth/setReady', value);
    },
    setTheme: function setTheme(theme) {
      context.store.commit('setTheme', theme);
      console.log('setTheme', theme);
    },
    get clientId() {
      return 'bcbc0d85416f43a8ba6c004a3f509692';
    },
    get scopes() {
      return ['employee'];
    },
    get headers() {
      return context.req ? context.req.headers : window.location;
    },
    get host() {
      return context.req ? context.req.headers.host : window.location.host;
    },
    get root() {
      var parts = this.host.split('.');
      return parts.length > 2 ? parts[2] : parts[1];
    },
    get domain() {
      var parts = this.host.split('.');
      return parts.length > 2 ? parts[1] : parts[0];
    },
    get location() {
      if (context.$config.forceLocation) {
        return context.$config.forceLocation;
      }
      var parts = this.host.split('.');
      return parts.length > 2 ? parts[0] : null;
    },
    get url() {
      return this.domain + '.' + this.root;
    },
    get active() {
      return context.store.getters['auth/active'];
    },
    get accounts() {
      return context.store.getters['auth/accounts'];
    },
    get accountIDs() {
      return context.store.getters['auth/guids'];
    },
    get info() {
      return context.store.getters['auth/info'];
    },
    get locked() {
      return context.store.getters['auth/locked'];
    },
    get ready() {
      return context.store.getters['auth/ready'];
    },
    get home() {
      return context.store.getters['auth/home'];
    },
    get sort() {
      return context.store.getters['auth/sort'];
    },
    get theme() {
      var _info$location7, _info$location7$locat;
      var info = context.store.getters['auth/info'];
      var theme = context.store.getters.theme;
      var code = theme || (info === null || info === void 0 ? void 0 : (_info$location7 = info.location) === null || _info$location7 === void 0 ? void 0 : (_info$location7$locat = _info$location7.locationTheme) === null || _info$location7$locat === void 0 ? void 0 : _info$location7$locat.code) || 'ovatu';
      return Themes[code] || Themes.ovatu;
    }
  };
  inject('auth', plugin);
  if (!Vue.prototype.authPlugin) {
    Object.defineProperty(Vue.prototype, 'authPlugin', {
      get: function get() {
        return plugin;
      }
    });
  }
  return plugin.init();
});